



















































































































































































/** @format */

import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import { cloneDeep } from 'lodash';
import { trim } from '@/utils/validators';
import Utils from '@/utils/common';
// axios请求
import { getAreaList } from '@/api/parking-space-list';
// 导入字典
import {
  useTypeMap,
  categoryMap,
  useStatusMap,
  spaceTypeMap,
  statusMap
} from '@/types/parking-space-management/dictionaries';

// form表单项定义
export interface IForm {
  parkId: string;
  areaId: string;
  code: string;
  category: string;
  spaceType: string;
  number: string;
  useType: string;
  useArea: string;
  status: string;
  useStatus: string;
}

@Component({
  components: { ParkingLotSearch }
})
export default class AddStall extends Vue {
  @Prop({ default: () => {} })
  dataForm!: any;

  @Prop()
  addparkId!: string;

  @Prop()
  onceAgen!: number;

  @Prop()
  packageId!: string;

  @Prop({ type: Boolean, default: false })
  isEdit!: boolean;

  @Prop({ type: Boolean, default: false })
  spinning!: boolean;

  parkId: string = '';
  areaId: string = '';
  code: string = '';
  category: string = '';
  spaceType: string = '';
  number: string = '';
  useType: string = '';
  useArea: string = '';
  numdisabled = true;
  // 表单
  form: any = null;
  areaList: any[] = [];
  validatorsTrim = trim;
  // spinning: boolean = false
  // @Watch('dataForm', { deep: true })
  // dataChanged(val: any) {
  //   this.init()
  //   this.enabled = val.enabled
  // }

  @Watch('addparkId', { deep: true })
  dataChanged(val: any) {
    // if (val === '') return this.$message.warning('请先选择车场在新增车位')
    this.parkId = val;
    this.init();
    this.getAreaList();
  }

  @Watch('packageId', { deep: true })
  packageIdChanged(val: any) {
    this.getAreaList();
  }

  @Watch('onceAgen', { deep: true })
  onceAgenhanged(val: any) {
    if (val) {
      this.form.setFieldsValue({ code: '' });
    }
  }
  // 车位用途
  useTypeList = Utils.toLabelVal(useTypeMap);
  // 车位类别
  categoryList = Utils.toLabelVal(categoryMap).splice(0, 3);
  // 使用状态
  useStatusList = Utils.toLabelVal(useStatusMap);
  // 车位类型
  spaceTypeList = Utils.toLabelVal(spaceTypeMap);
  // 车位状态
  statusList = Utils.toLabelVal(statusMap);

  // 生命周期初始化
  created() {
    this.init();
  }

  // 初始化form表单
  init() {
    if (this.isEdit && this.dataForm) {
      this.form = this.$form.createForm(this, {
        mapPropsToFields: () => {
          const {
            parkId,
            areaId,
            code,
            category,
            spaceType,
            number,
            useType,
            useArea,
            status,
            useStatus
          } = this.dataForm;
          return {
            useStatus: this.$form.createFormField({
              value: useStatus
            }),
            status: this.$form.createFormField({
              value: status
            }),
            parkId: this.$form.createFormField({
              value: parkId
            }),
            areaId: this.$form.createFormField({
              value: areaId
            }),
            code: this.$form.createFormField({
              value: code
            }),
            category: this.$form.createFormField({
              value: category
            }),
            spaceType: this.$form.createFormField({
              value: spaceType
            }),
            number: this.$form.createFormField({
              value: number
            }),
            useType: this.$form.createFormField({
              value: useType
            }),
            useArea: this.$form.createFormField({
              value: useArea
            })
          };
        }
      });
    } else {
      this.form = this.$form.createForm(this, {
        mapPropsToFields: () => {
          return {
            // 新增车场步骤进来，parkId自动带入表单
            parkId: this.$form.createFormField({
              value: this.addparkId || ''
            })
          };
        }
      });
      if (this.addparkId) {
        this.getAreaList();
      }
    }
  }

  // 获取区域数据
  async getAreaList() {
    try {
      const { data } = await getAreaList({
        parkId: this.addparkId,
        packageId: this.packageId
      });
      this.areaList = data;
      if (data && data.length > 0) {
        this.areaId = data[0].pkAreaId;
      } else {
        this.areaId = '';
      }
    } catch (error) {
      this.$message.error(error.msg);
      console.log('getAreaList error');
    }
  }
  // 提交监听处理
  async handleSubmit(e: any) {
    // console.log(e)
    e.stopPropagation();
    e.preventDefault();
    this.form.validateFields(async (err: boolean, values: IForm) => {
      if (!err) {
        this.$emit('addStailVal', values);
      }
    });
  }
  // 提交请求发送添加

  changeSpaceType(e: any) {
    console.log(e, 'e');
    if (e !== '03') {
      this.numdisabled = true;
      this.form.setFieldsValue({
        number: '1'
      });
    } else {
      this.numdisabled = false;
    }
  }
  /**
   * form布局
   */
  formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 14 }
    }
  };
  formItemLayout1 = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 }
    },
    wrapperCol: {
      xs: { span: 30 },
      sm: { span: 6 }
    }
  };
  tailFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 20,
        offset: 4
      },
      sm: {
        span: 18,
        offset: 6
      }
    }
  };
  centerFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 20,
        offset: 4
      },
      sm: {
        span: 10,
        offset: 14
      }
    }
  };
}
